var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo_box"},[_c('img',{staticStyle:{"max-width":"70%","width":"15%","margin-left":"20px","min-width":"10%","margin-right":"10px"},attrs:{"src":require("@/assets/img/NaHui.png")}}),_c('span',{staticClass:"title",staticStyle:{"color":"aliceblue","font-size":"14px"}},[_vm._v(" Nahui Intelligent ")])])
}]

export { render, staticRenderFns }